"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHomeWorld = createHomeWorld;
const world_1 = require("./world");
/**
 * The starting map: a two-room home with a doorway between them.
 *
 * Written as ASCII so the shape of the place is visible in the source. `#` is
 * wall, `.` is floor. The partition at column 7 has one gap, on row 5.
 */
const HOME_ROWS = [
    '################',
    '#......#.......#',
    '#......#.......#',
    '#......#.......#',
    '#......#.......#',
    '#..............#',
    '#......#.......#',
    '#......#.......#',
    '#......#.......#',
    '#......#.......#',
    '#......#.......#',
    '################',
];
const HOME_WIDTH = 16;
const HOME_HEIGHT = 12;
/** Bedroom on the left of the partition, living room on the right. */
const HOME_OBJECTS = [
    { id: 'bed-1', kind: 'bed', x: 1, y: 1 },
    { id: 'lamp-1', kind: 'lamp', x: 4, y: 1 },
    { id: 'rug-1', kind: 'rug', x: 3, y: 6 },
    { id: 'chest-1', kind: 'chest', x: 1, y: 9 },
    { id: 'plant-1', kind: 'plant', x: 6, y: 10 },
    { id: 'table-1', kind: 'table', x: 10, y: 4 },
    { id: 'chair-1', kind: 'chair', x: 9, y: 4 },
    { id: 'chair-2', kind: 'chair', x: 12, y: 5 },
    { id: 'rug-2', kind: 'rug', x: 9, y: 8 },
    { id: 'plant-2', kind: 'plant', x: 13, y: 1 },
    { id: 'lamp-2', kind: 'lamp', x: 14, y: 10 },
];
/**
 * A fresh copy of the home map.
 *
 * Always a new object graph: this is both the seed for a new player and the
 * target of dev mode's "reset", and either one handing out a shared instance
 * would let an edit leak into the next caller's world.
 */
function createHomeWorld() {
    return {
        id: 'home',
        name: 'Home',
        width: HOME_WIDTH,
        height: HOME_HEIGHT,
        tiles: (0, world_1.decodeTiles)(HOME_ROWS, HOME_WIDTH, HOME_HEIGHT),
        objects: HOME_OBJECTS.map((object) => ({ ...object })),
        spawn: { x: 4, y: 5 },
    };
}
//# sourceMappingURL=home.js.map